export default __webpack_public_path__ + "static/map-25a258a09a51a50fef34ce90a6e41262.png";